import { isForbiddenAccessError } from 'shared/errors/helpers/guards'

export const FORBIDDEN_REPORT_THROTTLE_MS = 10 * 60 * 1000

const lastReportedAtByTransaction = new Map<string, number>()

// One user polling a forbidden endpoint can flood Sentry with identical 403 events. The first 403
// per transaction is reported (and the window starts here), repeats inside the window are settled.
export const isSettledForbiddenReport = (exception: unknown): boolean => {
  if (!isForbiddenAccessError(exception)) return false

  const now = Date.now()
  const lastReportedAt = lastReportedAtByTransaction.get(exception.transaction)

  if (lastReportedAt !== undefined && now - lastReportedAt < FORBIDDEN_REPORT_THROTTLE_MS) {
    return true
  }

  lastReportedAtByTransaction.set(exception.transaction, now)
  return false
}
